import * as React from 'react';
import Link from '@mui/material/Link';
import PlaceIcon from '@mui/icons-material/Place';
import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Typography } from '@mui/material';
import MapLink from 'components/MapLink';

const runMapLink = "https://maps.app.goo.gl/vh15x3T3BBEqfwzf6";

type RunMapLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: RunMapLinkProps = {
  linkText: "Starting Location",
  underline: "hover"
};

export default function RunMapLink(linkProps: RunMapLinkProps = defaultProps) {
  const linkText = linkProps.linkText || defaultProps.linkText || "";
  const underline = linkProps.underline || defaultProps.underline; 
  return (
    <MapLink linkUrl={runMapLink} underline={underline}>{linkText}</MapLink>
  );
}